import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

const NON_RETRYABLE_STATUS = new Set([400, 401, 403, 404, 422]);

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) {
    return false;
  }

  const status = (error as AxiosError | undefined)?.response?.status;
  if (status && NON_RETRYABLE_STATUS.has(status)) {
    return false;
  }

  return true;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
